import React, { Component } from 'react'
import PropTypes from 'prop-types'

const shortcodes = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  CHF: 'Fr',
  CAD: 'C$',
  AUD: 'A$',
  BRL: 'R$',
  NZD: 'NZ$',
  JPY: '¥'
}

export default class Price extends Component {
  static propTypes = {
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    currency: PropTypes.string.isRequired,
    postPrice: PropTypes.string,
    itemProp: PropTypes.string
  }

  shouldComponentUpdate (nextProps) {
    return (
      this.props.price !== nextProps.price ||
      this.props.currency !== nextProps.currency ||
      this.props.postPrice !== nextProps.postPrice
    )
  }

  render () {
    const { currency, price, postPrice, itemProp, dataAttr } = this.props

    if (price === null || price === undefined || typeof price === 'undefined') {
      return null
    }

    const currencyCode = shortcodes[currency] || ' ' + currency
    const shortform = ((price - 0) * 100) % 100 === 0
    const inFront = currencyCode.indexOf('$') >= 0 || currencyCode === '£' || currencyCode == '¥'

    const result =
      (inFront ? currencyCode : '') +
      (shortform ? Math.floor(price - 0) : (price - 0).toFixed(2)) +
      (postPrice || '') +
      (inFront ? '' : currencyCode)

    return (
      <span itemProp={itemProp} data-attr={dataAttr}>
        {result}
      </span>
    )
  }
}
